import { render, staticRenderFns } from "./ScreenshotGalleryDialog.vue?vue&type=template&id=ab4ce12a&scoped=true&"
import script from "./ScreenshotGalleryDialog.vue?vue&type=script&lang=js&"
export * from "./ScreenshotGalleryDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotGalleryDialog.vue?vue&type=style&index=0&id=ab4ce12a&prod&lang=scss&"
import style1 from "./ScreenshotGalleryDialog.vue?vue&type=style&index=1&id=ab4ce12a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4ce12a",
  null
  
)

export default component.exports